/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  Collection,
  CollectionDescription,
  CollectionTitle,
  ContentPosition,
  DefaultLevel,
  EntityId,
  List,
  Space,
} from "./data-contracts";

/**
 * No description
 * @tags collections
 * @name GetCollectionById
 * @summary Get a collection by its ID
 * @request GET:/collections/{collectionId}
 * @secure
 */

// @ts-ignore
export const getCollectionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Collection;
  ResponseStatusCode: 200;
} = {
  route: "/collections/{collectionId}",
  method: "get",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collections
 * @name UpdateCollectionById
 * @summary Update a collection
 * @request PATCH:/collections/{collectionId}
 * @secure
 */

// @ts-ignore
export const updateCollectionById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the collection */
    title?: CollectionTitle;
    /** Description of the collection */
    description?: CollectionDescription;
    /** Default level for a piece of content */
    defaultLevel?: DefaultLevel;
  };
  RequestHeaders: {};
  ResponseBody: Collection;
  ResponseStatusCode: 200;
} = {
  route: "/collections/{collectionId}",
  method: "patch",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collections
 * @name DeleteCollectionById
 * @summary Delete a collection
 * @request DELETE:/collections/{collectionId}
 * @secure
 */

// @ts-ignore
export const deleteCollectionById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/collections/{collectionId}",
  method: "delete",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collections
 * @name ListSpacesInCollectionById
 * @summary List all collection spaces
 * @request GET:/collections/{collectionId}/spaces
 * @secure
 */

// @ts-ignore
export const listSpacesInCollectionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Space[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/collections/{collectionId}/spaces",
  method: "get",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collections
 * @name MoveCollection
 * @summary Move a collection to a new position.
 * @request POST:/collections/{collectionId}/move
 * @secure
 */

// @ts-ignore
export const moveCollection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** The unique id of the parent collection */
    parent?: string | null;
    /** Where to move the collection. By default, it will be moved at the end. */
    position?: ContentPosition;
  };
  RequestHeaders: {};
  ResponseBody: Collection;
  ResponseStatusCode: 200 | 400 | 404 | 409;
} = {
  route: "/collections/{collectionId}/move",
  method: "post",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collections
 * @name TransferCollection
 * @summary Transfer a collection
 * @request POST:/collections/{collectionId}/transfer
 * @secure
 */

// @ts-ignore
export const transferCollection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the collection */
    collectionId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** The unique id of the target organization */
    organization: string;
  };
  RequestHeaders: {};
  ResponseBody: Collection;
  ResponseStatusCode: 200 | 404 | 409 | 412;
} = {
  route: "/collections/{collectionId}/transfer",
  method: "post",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collections
 * @name ListCollectionsInOrganizationById
 * @summary List all collections
 * @request GET:/orgs/{organizationId}/collections
 * @secure
 */

// @ts-ignore
export const listCollectionsInOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If true, all nested collections will be listed
     * @default true
     */
    nested?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Collection[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/collections",
  method: "get",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collections
 * @name CreateCollection
 * @summary Create a collection
 * @request POST:/orgs/{organizationId}/collections
 * @secure
 */

// @ts-ignore
export const createCollection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /** @maxLength 50 */
        title?: string;
        /** ID of a parent collection */
        parent?: string;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: Collection;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/collections",
  method: "post",
  streaming: false,
  tags: ["collections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
